import React from 'react';
import Flex, { FlexProps } from '../Flex';

export type CenterProps = FlexProps;
const Center: React.FC<CenterProps> = ({ children, ...rest }) => {
  return <Flex {...rest}>{children}</Flex>;
};
Center.defaultProps = {
  justifyContent: 'center',
  align: 'center',
};
export default Center;
